import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { trackOrderStatus } from "../../../utility/analyticsUtility";

const PaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const orderId = searchParams.get('orderId');
    const orderValue = parseFloat(searchParams.get('orderValue') || '0');
    const paymentMethod = searchParams.get('paymentMethod') || 'Card';

    // Track cancelled payment
    if (orderId) {
      trackOrderStatus('cancelled', {
        orderId: orderId,
        orderValue: orderValue,
        paymentMethod: paymentMethod,
      });
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/checkout');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '50px 20px',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <div style={{ 
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeaa7',
        borderRadius: '8px',
        padding: '30px',
        marginBottom: '20px'
      }}>
        <h2 style={{ color: '#856404', marginBottom: '20px' }}>
          ⚠️ Payment Cancelled
        </h2>
        <p style={{ color: '#856404', fontSize: '18px' }}>
          You cancelled the payment process.
        </p>
      </div>

      <p>Redirecting back to checkout in <strong>{countdown}</strong> seconds...</p>
      
      <button 
        onClick={() => navigate('/checkout')}
        style={{
          padding: '12px 24px',
          backgroundColor: '#ffc107',
          color: '#212529',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
          marginTop: '20px'
        }}
      >
        Return to Checkout
      </button>
    </div>
  );
};

export default PaymentCancel;
